import React from 'react';
import PalQuizListPage from './PalQuizListPage';

const LearningPage = () => {
  return <PalQuizListPage title="Learning" quizType="Learning" basePath="/pal/learning" />;
};

export default LearningPage;
